import { hotRank } from "@/mocks/comics";

export default function HotRank() {
  return (
    <section id="hot" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-9 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="text-sm font-bold tracking-wide text-primary-600">HOT RANKING</span>
            <h2 className="mt-2 text-2xl font-black text-foreground-950 md:text-4xl">本周热门连载</h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              根据追更读者热度实时排名的爆款连载，反转与脑洞都被大家疯狂安利。
            </p>
          </div>
        </div>

        <ol className="space-y-3">
          {hotRank.map((item) => (
            <li
              key={item.id}
              className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-100 px-4 py-3.5 transition-colors hover:border-accent-300 hover:bg-background-50 md:gap-5 md:px-5"
            >
              <span
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl font-heading text-xl ${
                  item.rank <= 3 ? "bg-accent-500 text-foreground-950" : "bg-background-200 text-foreground-600"
                }`}
              >
                {item.rank}
              </span>
              <div className="flex min-w-0 flex-1 flex-col md:flex-row md:items-center md:justify-between md:gap-4">
                <div className="flex items-center gap-2 min-w-0">
                  <h3 className="truncate text-base font-bold text-foreground-950 md:text-lg">{item.title}</h3>
                  {item.badge && (
                    <span className={`rounded px-2 py-0.5 text-[11px] font-bold ${item.badge === "HOT" ? "bg-primary-500 text-background-50" : "bg-accent-500 text-foreground-950"}`}>
                      {item.badge}
                    </span>
                  )}
                </div>
                <div className="mt-1 flex items-center gap-3 text-sm text-foreground-500 md:mt-0">
                  <span className="whitespace-nowrap rounded bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">{item.category}</span>
                  <span className="whitespace-nowrap">
                    <i className="ri-fire-fill mr-1 text-primary-500"></i>
                    {item.followers} 人追更
                  </span>
                </div>
              </div>
              <a
                href="#updates"
                className="hidden shrink-0 items-center gap-1 rounded-full bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors group-hover:bg-accent-500 group-hover:text-foreground-950 md:inline-flex whitespace-nowrap"
              >
                去追更 <i className="ri-arrow-right-line"></i>
              </a>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}